import React from 'react';
import styled, { withTheme } from 'styled-components/macro';

import { Grid, AppBar, IconButton as MuiIconButton, Toolbar } from '@material-ui/core';

import { Menu as MenuIcon } from '@material-ui/icons';

import HelpButton from './HelpButton';
import LanguagesDropdown from './LanguagesDropdown';
import UserDropdown from './UserDropdown';
import { Hidden } from '../../../../types-hack';

const StyledAppBar = styled(AppBar)`
  background: ${props => props.theme.header.background};
  color: ${props => props.theme.header.color};
`;

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

type AppBarProps = {
  theme: {};
  onDrawerToggle: React.MouseEventHandler<HTMLElement>;
  helpRoute: string;
};

const AppBarComponent: React.FC<AppBarProps> = ({ onDrawerToggle, helpRoute }) => (
  <React.Fragment>
    <StyledAppBar position="sticky" elevation={0}>
      <Toolbar>
        <Grid container alignItems="center">
          <Hidden mdUp>
            <Grid item>
              <IconButton color="inherit" aria-label="Open drawer" onClick={onDrawerToggle}>
                <MenuIcon />
              </IconButton>
            </Grid>
          </Hidden>
          <Grid item xs />
          <Grid item>
            <HelpButton helpRoute={helpRoute} />
            <UserDropdown />
          </Grid>
        </Grid>
      </Toolbar>
    </StyledAppBar>
  </React.Fragment>
);

export default withTheme(AppBarComponent);
